import { StateCreator } from 'zustand';
import { allSlices, qnaSlice } from './interface';

const createQnaSlice: StateCreator<allSlices, [], [], qnaSlice> = (set) => ({
  notification: false,
  moreQna: true,
  questions: [],

  addAllQuestions: (questions) => {
    set((state) => ({
      qna: {
        ...state.qna,
        questions: [...questions, ...state.qna.questions]
      }
    }));
  },

  addQuestion: (question) => {
    set((state) => ({
      qna: {
        ...state.qna,
        questions: [...state.qna.questions, question]
      }
    }));
  },

  upvoteQuestion: (questionId: string, userId: string) =>
    set((state) => ({
      qna: {
        ...state.qna,
        questions: state.qna.questions.map((q) => {
          if (q._id !== questionId) return q;

          if (q.upVotedUserIds.includes(userId)) return q;

          return {
            ...q,
            upVotedUserIds: [...q.upVotedUserIds, userId]
          };
        })
      }
    })),

  markAnswered: (questionId) => {
    set((state) => ({
      qna: {
        ...state.qna,
        questions: state.qna.questions.map((q) =>
          q._id === questionId ? { ...q, isAnswered: true } : q
        )
      }
    }));
  },

  setQnaData: (data) => {
    set((state) => ({
      qna: { ...state.qna, ...data }
    }));
  }
});

export default createQnaSlice;
